import { useState, useEffect } from "react";
import { CreditCard, CheckCircle2, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LeadDialog } from "@/components/public/LeadDialog";
import { Seo } from "@/components/Seo";
import { api } from "@/lib/api";

export default function Financing() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setS(r.data || {})).catch(() => {}); }, []);
  const enabled = s.financing_enabled;
  const url = s.financing_url;
  return (
    <div data-testid="financing-page">
      <Seo title="Boat Financing | MTM Marine, Bristol, TN" description="Flexible boat financing options at MTM Marine in Bristol, TN. Apply online or talk with our team about getting on the water." />
      <section className="bg-mtm-charcoal text-white py-14">
        <div className="max-w-7xl mx-auto px-4">
          <p className="text-xs font-bold uppercase tracking-widest text-mtm-teal-bright font-mono">Make It Easy</p>
          <h1 className="text-4xl sm:text-5xl font-extrabold font-heading tracking-tight mt-2">Boat Financing</h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 py-16">
        <div className="bg-white rounded-2xl border border-slate-200 p-8 shadow-sm">
          <span className="h-14 w-14 rounded-xl bg-mtm-purple/10 text-mtm-purple flex items-center justify-center mb-5"><CreditCard size={28} /></span>
          <h2 className="font-heading font-bold text-2xl text-slate-900">Financing Made Simple</h2>
          <p className="text-slate-600 mt-3">MTM Marine helps boaters find financing that fits. {s.financing_provider ? `We work with ${s.financing_provider} to get you approved.` : "Talk with our team about current financing options."}</p>
          <ul className="mt-6 space-y-3">
            {["Competitive rates for qualified buyers", "Simple application process", "Financing for new and used boats", "Local, personal service"].map((t) => (
              <li key={t} className="flex items-center gap-2 text-slate-700"><CheckCircle2 size={18} className="text-mtm-teal" /> {t}</li>
            ))}
          </ul>
          <div className="flex flex-wrap gap-3 mt-8">
            {enabled && url && (
              <Button asChild size="lg" className="bg-mtm-purple hover:bg-mtm-purple-deep text-white rounded-full px-7" data-testid="financing-apply-button">
                <a href={url} target="_blank" rel="noreferrer">Apply for Financing <ExternalLink size={16} /></a>
              </Button>
            )}
            <LeadDialog ctaType="Financing Information" triggerLabel="Request Financing Info" variant={enabled && url ? "teal" : "purple"} size="lg" testId="financing-request-button" />
          </div>
          {!url && <p className="text-xs text-slate-400 mt-4">Online application coming soon, contact us and we'll walk you through it.</p>}
        </div>
      </section>
    </div>
  );
}
